import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "asset",
    "liability",
    "totalAssets",
    "totalLiabilities",
    "netWealth",
    "zakatDue",
    "payButton",
  ];

  connect() {
    this.calculate();
  }

  calculate() {
    const nisabThreshold = 8000;
    const zakatRate = 0.025;

    let totalAssets = 0,
      totalLiabilities = 0;
    this.assetTargets.forEach((i) => (totalAssets += parseFloat(i.value) || 0));
    this.liabilityTargets.forEach(
      (i) => (totalLiabilities += parseFloat(i.value) || 0)
    );
    const net = totalAssets - totalLiabilities;
    const zakat = net > nisabThreshold ? net * zakatRate : 0;

    this.totalAssetsTarget.textContent = totalAssets.toFixed(2);
    this.totalLiabilitiesTarget.textContent = totalLiabilities.toFixed(2);
    this.netWealthTarget.textContent = net.toFixed(2);
    this.zakatDueTarget.textContent = zakat.toFixed(2);

    // Enable or disable the pay button based on the net wealth
    if (net >= nisabThreshold) {
      this.payButtonTarget.disabled = false;
      this.payButtonTarget.classList.remove("cursor-not-allowed", "opacity-50");
    } else {
      this.payButtonTarget.disabled = true;
      this.payButtonTarget.classList.add("cursor-not-allowed", "opacity-50");
    }
  }

  // Method to trigger modal update when pay button is clicked
  openPaymentModal() {
    // Find the zakat modal controller and trigger its update
    const modalElement = document.querySelector(
      '[data-controller*="zakat-modal"]'
    );
    if (modalElement) {
      const controller = this.application.getControllerForElementAndIdentifier(
        modalElement,
        "zakat-modal"
      );
      if (controller) {
        // Small delay to ensure modal is shown first
        setTimeout(() => {
          controller.updateModalContent();
        }, 100);
      }
    }
  }
}
